module.exports = __webpack_public_path__ + "static/media/member-3.e6f7619e.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Team/assets/member-3.png
// module id = 1096
// module chunks = 0